import script from "./RecetaList.vue?vue&type=script&setup=true&lang=js"
export * from "./RecetaList.vue?vue&type=script&setup=true&lang=js"

import "./RecetaList.vue?vue&type=style&index=0&id=6417fb40&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6417fb40"]])

export default __exports__